import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { Axios } from "axios";

//ACTIONS
import * as UserProfileActions from "../../../../../../../store/actions/userProfile";
import * as GlobalVarsActions from "../../../../../../../store/actions/globalVars";
import * as BookingDataActions from "../../../../../../../store/actions/bookingData";

//COMPONENTS
import Timetable from "./roomTemplates/timetable";
import Diary from "./roomTemplates/diary";
import BookingCanvas from "./bookingCanvas";
import { GetRoomBookings } from "../../../../portalHome";

//STYLES
import * as RoomViewStyles from "../styles/roomView";

function RoomView() {
    const params = useParams();
    const dispatch = useDispatch();
    const organisation = useSelector((state) => state.organisation);
    const userProfile = useSelector((state) => state.userProfile);
    const globalVars = useSelector((state) => state.globalVars);

    //REFS
    const layoutView = useRef(null);

    const [room, setRoom] = useState([]);
    const [layout, setLayout] = useState([]);
    const [weekBG, setWeekBG] = useState(moment());

    useEffect(() => {
        const date = moment().startOf("week");
        setWeekBG(date);
        dispatch(GlobalVarsActions.UpdateTopControls_weekBG(date));
        CheckHoliday(date);

        if (layoutView.current != null) {
            console.log(layoutView.current.clientHeight);
        }
    }, []);

    useEffect(() => {
        const room = organisation.rooms.find((room) => room.uuid == params.id);
        const layoutData = organisation.layouts.find((layout) => layout.uuid == room.layout);
        console.log(room);
        setRoom(room);
        setLayout(layoutData);

        dispatch(GlobalVarsActions.UpdateRoomName(room.name));
        dispatch(GlobalVarsActions.UpdateRoomID(params.id));
        dispatch(GlobalVarsActions.UpdateRoomWeekSystem(room.weekSystem));
        dispatch(GlobalVarsActions.UpdateRoomLayoutData(layoutData));
        dispatch(GlobalVarsActions.UpdateRoomDayList(layoutData.days));

        UpdateRoomProfileSettings(room.uuid);
        dispatch(GlobalVarsActions.UpdateMenuID("rooms", params.id));
    }, [params.id]);

    function CheckHoliday(weekBG) {
        const room = organisation.rooms.find((room) => room.uuid == params.id);

        const date = moment(weekBG, "DD/MM/YYYY");
        const week = formatString(date.week()) + "-" + date.format("YY");
        let holidayTitle = "";
        for (const holiday of organisation.holidays) {
            if (holiday.weeks.includes(week)) {
                if (holiday.titleUUID.includes("w")) {
                    if (room.weekSystem) {
                        holidayTitle = holiday.name;
                    }
                } else if (holiday.titleUUID.includes("h")) {
                    holidayTitle = "Holiday: " + holiday.name;
                }
                dispatch(GlobalVarsActions.UpdateRoomWeekUUID(holiday.titleUUID));
                break;
            }
        }
        dispatch(GlobalVarsActions.UpdateTopControls_Holiday(holidayTitle));
    }

    function UpdateRoomProfileSettings(roomUUID) {
        const roomSettings = userProfile.rooms.find((settings) => settings.roomUUID == roomUUID);

        dispatch(UserProfileActions.UpdateRoom_View(roomSettings.prop_View == "true"));
        dispatch(UserProfileActions.UpdateRoom_Write(roomSettings.prop_Write == "true"));
        dispatch(UserProfileActions.UpdateRoom_Edit(roomSettings.prop_Edit == "true"));
        dispatch(UserProfileActions.UpdateRoom_Delete(roomSettings.prop_Delete == "true"));
        dispatch(UserProfileActions.UpdateRoom_Repeat(roomSettings.prop_Repeat == "true"));
    }

    return (
        <div style={{ height: "100%" }}>
            <Row style={{ height: "100%" }}>
                <Col>
                    <div style={{ height: "100%" }}>
                        {organisation.locked && <div style={RoomViewStyles.orgLocked}>Organisation Locked</div>}
                        {layout != null && layout.layout == "Timetable" && (
                            <div style={RoomViewStyles.timetableContiner}>
                                <Timetable
                                    orgID={params.orgID}
                                    layoutData={layout}
                                    roomName={room.mame}
                                    weekBG={weekBG}
                                    roomID={params.id}
                                    weekSystem={room.weekSystem}
                                />
                            </div>
                        )}
                        {layout != null && layout.layout == "Diary" && (
                            <div style={RoomViewStyles.diaryContainer}>
                                <div style={RoomViewStyles.diaryInnerContainer}>
                                    <Diary
                                        orgID={params.orgID}
                                        roomName={room.mame}
                                        weekBG={weekBG}
                                        roomID={params.id}
                                        layoutData={layout}
                                        weekSystem={room.weekSystem}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            <BookingCanvas />
        </div>
    );
}

////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

export function TopControls() {
    const globalVars = useSelector((state) => state.globalVars);
    const userProfile = useSelector((state) => state.userProfile);
    const organisation = useSelector((state) => state.organisation);
    const bookingData = useSelector((state) => state.bookingData);

    const dispatch = useDispatch();

    const [modal, setModal] = useState({
        open: false,
        heading: "",
        message: ""
    });

    function handleModalClose() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    async function handleAdvanceWeek() {
        const newDate = moment(globalVars.topControls.weekBG.add(1, "w"));
        dispatch(GlobalVarsActions.UpdateTopControls_weekBG(newDate));
        CheckHoliday(newDate);

        //GET BOOKINGS
        const data = await GetRoomBookings(bookingData.orgID, bookingData.roomID, newDate, bookingData.days);
        dispatch(
            BookingDataActions.UpdateBookingData(
                data.data,
                data.orgID,
                data.roomID,
                data.weekSlot,
                data.days,
                globalVars.roomDetail.layoutData.days,
                data.weekBG
            )
        );
    }

    async function handleGoBackWeek() {
        const week = moment(globalVars.topControls.weekBG.subtract(1, "w"));
        console.log(week);
        let pastDate = moment();
        pastDate.startOf("week");

        pastDate.subtract(parseInt(userProfile.userSettings.weeks.goBackWeeks), "weeks");

        if (week < pastDate) {
            setModal({ heading: globalVars.roomDetail.roomName, message: "You cannot go back previous from this week", open: true });
            globalVars.topControls.weekBG.add(1, "w");
        } else {
            dispatch(GlobalVarsActions.UpdateTopControls_weekBG(week));
            CheckHoliday(week);

            //GET BOOKINGS
            const data = await GetRoomBookings(bookingData.orgID, bookingData.roomID, week, bookingData.days);
            dispatch(
                BookingDataActions.UpdateBookingData(
                    data.data,
                    data.orgID,
                    data.roomID,
                    data.weekSlot,
                    data.days,
                    globalVars.roomDetail.layoutData.days,
                    data.weekBG
                )
            );
        }
    }

    function CheckHoliday(weekBG) {
        const date = moment(weekBG, "DD/MM/YYYY");
        const week = formatString(date.week()) + "-" + date.format("YY");
        let holidayTitle = "";

        for (const holiday of organisation.holidays) {
            if (holiday.weeks.includes(week)) {
                if (holiday.titleUUID.includes("w")) {
                    if (globalVars.roomDetail.weekSystem) {
                        holidayTitle = holiday.name;
                        console.log(holiday.titleUUID);
                    }
                } else if (holiday.titleUUID.includes("h")) {
                    holidayTitle = "Holiday: " + holiday.name;
                }
                dispatch(GlobalVarsActions.UpdateRoomWeekUUID(holiday.titleUUID));
                break;
            }
        }

        dispatch(GlobalVarsActions.UpdateTopControls_Holiday(holidayTitle));
    }

    return (
        <div>
            <Row>
                <Col sm={4} style={{ ...RoomViewStyles.topControls }}>
                    <strong>Week Beginning: {globalVars.topControls.weekBG != "" && globalVars.topControls.weekBG.format("DD/MM/YYYY")}</strong>
                </Col>
                <Col sm={4} style={RoomViewStyles.topControls}>
                    <strong> {globalVars.topControls.holiday}</strong>
                </Col>
                <Col sm={4} style={{ ...RoomViewStyles.buttons }}>
                    <div className="topSection_leftButton" onClick={handleGoBackWeek}>
                        <i className="fa-solid fa-angle-left"></i>{" "}
                    </div>
                    <div className="topSection_rightButton" onClick={handleAdvanceWeek}>
                        <i className="fa-solid fa-angle-right"></i>
                    </div>
                </Col>
            </Row>
            <Modal show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleModalClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

function formatString(time) {
    if (time.toString().includes("b")) {
        time = time.replace("b", "");

        if (time.toString().length == 1) {
            return "b0" + time;
        } else {
            return time;
        }
    } else {
        if (time.toString().length == 1) {
            return "0" + time;
        } else {
            return time;
        }
    }
}

export default RoomView;
